import {RouterProvider, createBrowserRouter} from "react-router-dom";
import {ProtectedRoute} from "../auth/ProtectedRoute";
import Login from "../auth/Login";
import Logout from "../auth/Logout";
import ResourceNew from "../features/resources/ResourceNew";
import ResourceEdit from "../features/resources/ResourceEdit";
import {clients, deviceTypes, products, serviceItems} from "../features/resources/resources";
import Home from "../features/home/Home";
import Accounting from "../features/accounting/Accounting";
import Config from "../features/config/Config";
import ConfigEdit from "../features/config/ConfigEdit";
import PasswordChange from "../features/config/PasswordChange";
import Orders from "../features/orders/Orders";
import OrderDetail from "../features/orders/OrderDetail";
import OrderEdit from "../features/orders/OrderEdit";
import OrderPrint from "../features/orders/OrderPrint";
import OrderNew from "../features/orders/OrderNew";
import Changelog from "../features/changelog/Changelog";
import Notifications from "../features/notifications/Notifications";
import Clients from "../features/clients/Clients";
import ClientDetail from "../features/clients/ClientDetail";
import ServiceItems from "../features/serviceItems/ServiceItems";
import ServiceItemDetail from "../features/serviceItems/ServiceItemDetail";
import Products from "../features/products/Products";
import ProductDetail from "../features/products/ProductDetail";
import DeviceTypes from "../features/deviceTypes/DeviceTypes";
import DeviceTypeDetail from "../features/deviceTypes/DeviceTypeDetail";
import Quote from "../features/quotes/Quote";
import Showcase from "../features/showcase/Showcase";

// Created once: auth state is read by the route elements, so the router
// must not be rebuilt when the token changes.
const router = createBrowserRouter([
    {path: "/about", element: <div>Sobre</div>},
    // Public: a provider's page for their clients, no login (found by showcase name).
    {path: "/p/:showcaseName", element: <Showcase />},
    // Public: an order for its customer, found by the token in the link they were sent.
    {path: "/quotes/:token", element: <Quote />},
    {path: "/login", element: <Login />},
    {path: "/logout", element: <Logout />},
    // Logged in, but with none of the app's chrome: it is a sheet of paper.
    {element: <ProtectedRoute bare />, children: [{path: "/orders/:id/print", element: <OrderPrint />}]},
    {
        element: <ProtectedRoute />,
        children: [
            {path: "/", element: <Home />},
            {path: "/accounting", element: <Accounting />},
            {path: "/config", element: <Config />},
            {path: "/config/edit", element: <ConfigEdit />},
            {path: "/config/password", element: <PasswordChange />},
            {path: "/orders", element: <Orders />},
            {path: "/orders/new", element: <OrderNew />},
            {path: "/orders/:id", element: <OrderDetail />},
            {path: "/orders/:id/edit", element: <OrderEdit />},
            {path: "/changelog", element: <Changelog />},
            {path: "/notifications", element: <Notifications />},
            {path: "/clients", element: <Clients />},
            {path: "/clients/new", element: <ResourceNew resource={clients} />},
            {path: "/clients/:id", element: <ClientDetail />},
            {path: "/clients/:id/edit", element: <ResourceEdit resource={clients} />},
            {path: "/service-items", element: <ServiceItems />},
            {path: "/service-items/new", element: <ResourceNew resource={serviceItems} />},
            {path: "/service-items/:id", element: <ServiceItemDetail />},
            {path: "/service-items/:id/edit", element: <ResourceEdit resource={serviceItems} />},
            {path: "/products", element: <Products />},
            {path: "/products/new", element: <ResourceNew resource={products} />},
            {path: "/products/:id", element: <ProductDetail />},
            {path: "/products/:id/edit", element: <ResourceEdit resource={products} />},
            {path: "/device-types", element: <DeviceTypes />},
            {path: "/device-types/new", element: <ResourceNew resource={deviceTypes} />},
            {path: "/device-types/:id", element: <DeviceTypeDetail />},
            {path: "/device-types/:id/edit", element: <ResourceEdit resource={deviceTypes} />},
        ],
    },
]);

const Routes = () => <RouterProvider router={router} />;

export default Routes;
